import { InputAdornment } from '@mui/material';
import CustomTextField from '@components/CustomTextField';

function PixelInput({
    dataKey,
    value,
    title,
    helperText = null,
    error = false,
    onChange,
    inputProps = {}
}) {
    //change input in state
    const handleInputChange = e => {
        const { value } = e.target;

        onChange({
            target: {
                value: value + 'px',
                name: dataKey
            }
        });
    };

    let numberValue = value;

    if (typeof numberValue.endsWith !== 'undefined' && numberValue?.endsWith('px')) {
        numberValue = numberValue.replace('px', '');
    }

    return (
        <CustomTextField
            description={helperText}
            error={error}
            errorMsg={helperText}
            fieldKey={dataKey}
            handleChange={handleInputChange}
            inputProps={{
                InputProps: {
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    endAdornment: <InputAdornment position='end'>px</InputAdornment>
                },
                type: 'number',
                ...inputProps
            }}
            label={title}
            value={numberValue}
        />
    );
}

export default PixelInput;
